import { t } from 'ember-intl';

<template>
  {{#if @flash.rawString}}
    {{! template-lint-disable no-triple-curlies }}
    <p>{{{@flash.message}}}</p>
    {{! template-lint-enable no-triple-curlies }}
  {{else}}
    <p>{{t @flash.message htmlSafe=true}}</p>
  {{/if}}
</template>
